import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Fui por primera vez con mucho miedo a que quedara artificial. La doctora me escuchó, me explicó todo y el resultado de mi Botox fue increíble. Súper natural, me veo descansada.',
  name: 'Valentina R.',
  treatment: 'Tratamiento: Botox',
  initials: 'VR'
}, {
  quote: 'El nivel de profesionalismo es de otro planeta. Me hice un protocolo de Skin Quality y mi piel nunca estuvo tan luminosa. Vale cada peso invertido, la confianza no tiene precio.',
  name: 'Sofía M.',
  treatment: 'Tratamiento: Skin Quality',
  initials: 'SM'
}, {
  quote: 'Me encanta que sean médicas reales. Te hacen un diagnóstico súper completo antes de tocarte la cara. Me hice láser y los resultados superaron mis expectativas ampliamente.',
  name: 'Camila G.',
  treatment: 'Tratamiento: Láser',
  initials: 'CG'
}];
export function Testimonials() {
  return <section id="resultados" className="py-24 bg-ivory" data-id="element-161">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-162">
        <div className="text-center mb-16" data-id="element-163">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-serif text-3xl md:text-4xl text-charcoal" data-id="element-164">
            Lo que dicen nuestras pacientes
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-165">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-soft border-t-4 border-rosegold relative" data-id="element-166">
              <div className="flex gap-1 text-rosegold mb-6" data-id="element-167">
                {[...Array(5)].map((_, j) => <Star key={j} size={18} fill="currentColor" data-id="element-168" />)}
              </div>
              <p className="font-serif italic text-charcoal/80 text-lg mb-8 leading-relaxed" data-id="element-169">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-170">
                <div className="w-12 h-12 bg-rosegold/10 rounded-full flex items-center justify-center text-rosegold font-serif font-bold text-lg" data-id="element-171">
                  {t.initials}
                </div>
                <div data-id="element-172">
                  <h4 className="font-semibold text-charcoal" data-id="element-173">{t.name}</h4>
                  <p className="text-sm text-charcoal/50" data-id="element-174">{t.treatment}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}